// ==========================================================================
// Debugger Helper for WeLearn Pro Player
//
// Copyrights 2019 Wewasanad Co.,Ltd.
// ES6-ify from: https://gist.github.com/bgrins/5108712
// This module is based on the 'console.js' module of Plyr.js by Sam Potts under the MIT License (MIT)
// ==========================================================================

// Blank function for ternary else case
const noop = () => {
};

/**
 * Class consists debugging utility functions designed for WeLearn Pro Player
 */
export default class Debug {
    constructor(enabled = false) {
        this.enabled = enabled && window.console;
    }

    get log() {
        return this.enabled ? Function.prototype.bind.call(console.log, console) : noop;
    }

    get warn() {
        return this.enabled ? Function.prototype.bind.call(console.warn, console) : noop;
    }

    get error() {
        return this.enabled ? Function.prototype.bind.call(console.error, console) : noop;
    }
}